function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   display: block;\n   width: 100%;\n   height: calc(1.5em + 0.75rem + 2px);\n   padding: 0.375rem 0.75rem;\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #495057;\n   background-color: #fff;\n   background-clip: padding-box;\n   border: 1px solid #ced4da;\n   transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n   margin-bottom: 1em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var Input = styled.input(_templateObject());
export { Input };